import type { FC } from "react";

import { AchievementIcon } from "components";

interface Props {
  icon: string;
  count: number | null;
  isEarned: boolean;
  title: string;
  id: string;
  isNewBadge?: boolean;
  onClick: null | ((id: string) => void);
}

const AchievementBadge: FC<Props> = ({ icon, count, isEarned, title, isNewBadge = false, id, onClick }) => {
  const handleClick = () => {
    if (onClick === null) return;

    onClick(id);
  };

  return (
    <div
      className={`${onClick === null ? "" : "achievement achievement--narrow"} ${
        isEarned ? "" : "achievement--inactive"
      }`}
      onClick={handleClick}
    >
      <AchievementIcon icon={icon} count={count} />
      <p>
        <strong>{title}</strong>
      </p>
    </div>
  );
};

export default AchievementBadge;
